import React, { Component, Fragment } from "react";
import classNames from "classnames";
import { push } from "connected-react-router";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";

import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";

class ExpiredByMaxAtemps extends Component {
    send = (event) => {
        this.props.dispatch(push("/"));
    };

    getContent = () => (
        <div className="above-the-fold login-desktop-wrapper">
            <I18n
                component="h2"
                componentProps={{ className: "title-content text-center" }}
                id="session.expiredByMaxAtemps.title"
            />

            <Button
                className="mt-8"
                label="session.expiredByMaxAtemps.loginAgain"
                loading={false}
                onClick={this.send}
                type="button"
                bsStyle="primary"
                block
            />
        </div>
    );

    render() {
        const mainContainerClass = classNames({
            "main-container": true,
            "container-fluid": this.props.isDesktop,
        });

        return (
            <Fragment>
                <MainContainer className={mainContainerClass}>{this.getContent()}</MainContainer>
            </Fragment>
        );
    }
}

export default connect(null)(ExpiredByMaxAtemps);
